// extracted by mini-css-extract-plugin
export default {"container":"vB-z","modal":"wB-z","dimensions":"xB-z","brandName":"yB-z","productName":"zB-z","labelValue":"AB-z","recipientEmail":"BB-z","recommendedFit":"CB-z","hiddenField":"DB-z"};